'use client';

import illustration from '../../public/logo-142.png';
import Image from 'next/image';
import Button from '~/components/Button';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

export default function NotFound() {
  const router = useRouter();

  const handleBack = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <div className="flex w-full h-full">
      <div className="w-full flex items-center justify-center">
        <div className="max-w-[90%]">
          <div className="flex justify-center mb-3">
            <Image src={illustration.src} alt="illustration" width={142} height={142} />
          </div>
          <div className="text-center basis-full">
            <h1 className="text-4xl font-semibold">That page does not exist.</h1>
            <p className="mt-3 mb-6">
              Head to the other pages that do exist, or check our help section.
            </p>
          </div>
          <div>
            <Button
              label={<div className="flex items-center text-white">Go back</div>}
              className="bg-[#0B0B0B] w-full"
              onClick={handleBack}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
